const searchInput = document.getElementById('faq-search-input')
const searchButton = document.getElementById('faq-search-button')
const noResults = document.getElementById('faq-no-results')
const categories = document.querySelectorAll('.faq-page__category')
const sidebarLinks = document.querySelectorAll('.faq-page__sidebar-link')

const normalize = (text) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

const filterQuestions = () => {
    if (!searchInput) {
        return
    }

    const term = normalize(searchInput.value.trim())
    let visibleQuestionsCount = 0

    categories.forEach((category) => {
        let categoryHasVisibleQuestions = false

        category.querySelectorAll('[data-faq-question]').forEach((question) => {
            const questionText = normalize(question.querySelector('[data-faq-question-text]').textContent)
            const isMatch = term === '' || questionText.includes(term)

            question.hidden = !isMatch

            if (isMatch) {
                categoryHasVisibleQuestions = true
                visibleQuestionsCount += 1
            }
        })

        category.hidden = !categoryHasVisibleQuestions

        const sidebarLink = document.querySelector(`[data-faq-category-link="${category.dataset.faqCategory}"]`)
        if (sidebarLink) {
            sidebarLink.classList.toggle('--dimmed', !categoryHasVisibleQuestions)
        }
    })

    if (noResults) {
        noResults.hidden = visibleQuestionsCount !== 0
    }
}

const setActiveSidebarLink = (categoryId) => {
    sidebarLinks.forEach((link) => {
        link.classList.toggle('--active', link.dataset.faqCategoryLink === categoryId)
    })
}

if (searchInput) {
    searchInput.addEventListener('input', filterQuestions)
}

if (searchButton) {
    searchButton.addEventListener('click', (event) => {
        event.preventDefault()
        filterQuestions()
    })
}

if (categories.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveSidebarLink(entry.target.dataset.faqCategory)
                }
            })
        },
        { rootMargin: '-20% 0px -70% 0px' }
    )

    categories.forEach((category) => observer.observe(category))
}
